import Repository from '../axios'
import { defaultPagination } from '@/constants/config';

const resource = "/admin/supplier/raw_material_carriers";

export default {
  getListOfMembers() {
    return Repository.get(`/admin/mail-chimp/audiences/b8741efc4b/members`)
  },
  getMemberDetails(email) {
    return Repository.get(`/admin/mail-chimp/audiences/b8741efc4b/members/${email}`)
  },
  createMember(payload) {
    return Repository.post(`/admin/mail-chimp/audiences/b8741efc4b/members`, payload)
  },
  getListOfMarketingLeads(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/admin/marketing/leads?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  fetchMergedFields() {
    return Repository.get('/admin/mail-chimp/audience/merge-fields')
  },
  createMarketingLead(payload) {
    return Repository.post('/admin/marketing/leads' , payload)
  },
  getMerketingLeadDetails(id) {
    return Repository.get(`/admin/marketing/leads/${id}`)
  },
  updateMerketingLead(id, payload) {
    return Repository.put(`/admin/marketing/leads/${id}`, payload)
  },
  changeMarketingLeadStatus(id, payload) {
    return Repository.put(`/admin/marketing/lead/${id}/status`, payload)
  },
  createBantForMarketingLead(id, payload) {
    return Repository.post(`/admin/marketing/leads/${id}/bants`, payload)
  },
  getBantDataForLead(id) {
    return Repository.get(`/admin/marketing/leads/${id}/bants`)
  },
  getCrmMergedFields() {
    return Repository.get('/admin/marketing/lead/merge-fields')
  },
  getCrmMergedFieldDetails(id) {
    return Repository.get(`/admin/marketing/lead/merge-fields/${id}`)
  },
  createCrmMergedFields(payload) {
    return Repository.post('/admin/marketing/lead/merge-fields', payload)
  },
  updateCrmMergedFields(id, payload) {
    return Repository.put(`/admin/marketing/lead/merge-fields/${id}`, payload)
  },
  downloadExcelTemplate() {
    return Repository.get('/admin/marketing/lead/upload-template',  {responseType:'blob'})
  },
  //LEAD ADDRESS
  getLeadAddressList(id) {
    return Repository.get(`/admin/marketing/lead/addresses?customer_lead_id=${id}`)
  },

  //LEAD SITES
  getLeadSiteList(id, pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`/admin/marketing/lead/sites?customer_lead_id=${id}&paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getLeadSiteDetails(id) {
    return Repository.get(`/admin/marketing/lead/sites/${id}`)
  },
  createLeadSite(payload) {
    return Repository.post(`/admin/marketing/lead/sites`, payload)
  },
  updateLeadSite(id, payload) {
    return Repository.put(`/admin/marketing/lead/sites/${id}`, payload)
  },

  //customer crm 
  getListOfCustomerContacts(customer_id, pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`/admin/customer/crm/communications?customer_id=${customer_id}&?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  createCustomerCrmContact(payload) {
    return Repository.post('/admin/customer/crm/communications', payload)
  },
  getCustomerCrmContact(id) {
    return Repository.get(`/admin/customer/crm/communications/${id}`)
  },
  updateCustomerCrmContact(id, payload) {
    return Repository.put(`/admin/customer/crm/communications/${id}`, payload)
  },
  viewCustomerCrmContactSummary(id) {
    return Repository.get(`/admin/customer/crm/communication/${id}/summary`)
  },
  //CRM CONTACT SUBJECT SETTINGS
  getListOfSubjects(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/admin/system_setting/customer/communication-subjects?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  deleteCrmSubject(id) {
    return Repository.delete(`/admin/system_setting/customer/communication-subjects/${id}`)
  },
  createCrmSubject(payload) {
    return Repository.post(`/admin/system_setting/customer/communication-subjects`, payload)
  },
  updateCrmSubject(id, payload) {
    return Repository.put(`/admin/system_setting/customer/communication-subjects/${id}`, payload)
  },
  getCrmSubject(id) {
    return Repository.get(`/admin/system_setting/customer/communication-subjects/${id}`)
  },
  //customer crm opportunity
  getListOfCustomerOpportunity(customer_id, pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`/admin/customer/crm/opportunities?customer_id=${customer_id}&?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  createCustomerCrmOpportunity(payload) {
    return Repository.post('/admin/customer/crm/opportunities', payload)
  },
  getCustomerCrmOpportunity(id) {
    return Repository.get(`/admin/customer/crm/opportunities/${id}`)
  },
  updateCustomerCrmOpportunity(id, payload) {
    return Repository.put(`/admin/customer/crm/opportunities/${id}`, payload)
  },
  createOpprtunityBantProcess(id, payload) {
    return Repository.post(`/admin/customer/crm/opportunities/${id}/bants`, payload)
  },
  getBantDataForOpportunity(id) {
    return Repository.get(`/admin/customer/crm/opportunities/${id}/bants`)
  },
  changeOpportunityStatus(id, payload) {
    return Repository.put(`/admin/customer/crm/opportunity/${id}/status`, payload)
  },
  syncOpportunityWithOrders(id, payload) {
    return Repository.put(`/admin/customer/crm/opportunity/${id}/link-orders`, payload)
  },
  checkProductsWithExistingOpportunity(customer_id, product_id, opportunity_id = null) {
    return Repository.get(`/admin/customer/crm/opportunity/filter-products?customer_id=${customer_id}&product_id=${product_id}&opportunity_id=${opportunity_id}`)
  },
  getOpportunityValueFromForecaseTool(payload) {
    return Repository.post(`/admin/sales/forecast-tool/value-by-products`, payload)
  },

  // indirect channel
  createCrmIndirectChannel(id, payload) {
    return Repository.post(`/admin/marketing/leads/${id}/indirect-channels`, payload)
  },
  createCrmIndirectChannelCommission(id, payload) {
    return Repository.post(`/admin/marketing/indirect-channels/${id}/commissions`, payload)
  },
  getListOfIndirectChannels(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/admin/marketing/indirect-channels?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getIndirectChannelDetails(id) {
    return Repository.get(`/admin/marketing/indirect-channels/${id}`)
  },
  createIndirectChannelPartner(payload) {
    return Repository.post(`/admin/marketing/indirect-channels`, payload)
  },
  updateIndirectChannelPartner(id, payload) {
    return Repository.put(`/admin/marketing/indirect-channels/${id}`, payload)
  },
  changeIndirectChannelPartnerStatus(id, payload) {
    return Repository.put(`/admin/marketing/indirect-channel/${id}/status`, payload)
  },
  createIndirectChannelCustomer(id, payload) {
    return Repository.post(`/admin/marketing/indirect-channels/${id}/indirect-customers`, payload)
  },
  createIndirectChannelProduct(id, payload) {
    return Repository.post(`/admin/marketing/indirect-customers/${id}/products`, payload)
  },
  indirectChannelProductStatusChange(id, payload) {
    return Repository.put(`/admin/marketing/indirect-channel/product/${id}/status`, payload)
  },
  updateProductAgreement(id, payload) {
    return Repository.put(`/admin/marketing/products/${id}`, payload)
  },
  checkProductAvailability(params) {
    return Repository.get(`/admin/marketing/indirect-channel/product/existing-link?${params}`)
  },
  getIndirectChannelSummary(channel_id, from = '01/01/2023' , to = '12/12/2026') {
    return Repository.get(`/admin/marketing/indirect-channel/${channel_id}/summary?from=${from}&to=${to}`)
  },

  //VAM Type 
  getListVamType(is_paginate = 0) {
    return Repository.get(`/admin/system_setting/customer/snapshot-vam-types?is_paginate=${is_paginate}`)
  },
  deleteCrmVamType(id) {
    return Repository.delete(`/admin/system_setting/customer/snapshot-vam-types/${id}`)
  },
  createCrmVamType(payload) {
    return Repository.post(`/admin/system_setting/customer/snapshot-vam-types`, payload)
  },
  updateCrmVamType(id, payload) {
    return Repository.put(`/admin/system_setting/customer/snapshot-vam-types/${id}`, payload)
  },
  getCrmVamType(id) {
    return Repository.get(`/admin/system_setting/customer/snapshot-vam-types/${id}`)
  },
  reorderCrmVamTypes(payload) {
    return Repository.post(`/admin/system_setting/customer/snapshot-vam-types/reorder`, payload)
  },

    //VAM REASON CODES 
    getListVamReasonCode(is_paginate = 0) {
      return Repository.get(`/admin/system_setting/customer/snapshot-vam-reason-codes?is_paginate=${is_paginate}`)
    },
    deleteCrmVamReasonCode(id) {
      return Repository.delete(`/admin/system_setting/customer/snapshot-vam-reason-codes/${id}`)
    },
    createCrmVamReasonCode(payload) {
      return Repository.post(`/admin/system_setting/customer/snapshot-vam-reason-codes`, payload)
    },
    updateCrmVamReasonCode(id, payload) {
      return Repository.put(`/admin/system_setting/customer/snapshot-vam-reason-codes/${id}`, payload)
    },
    getCrmVamReasonCode(id) {
      return Repository.get(`/admin/system_setting/customer/snapshot-vam-reason-codes/${id}`)
    },

  //crm cnapshot
  getListOfCustomerSnapshot(customer_id, pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`/admin/customer/crm/snapshots?customer_id=${customer_id}&paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  createCustomerSnapshot(payload) {
    return Repository.post('/admin/customer/crm/snapshots', payload)
  },
  getCustomerCrmSnapshot(id) {
    return Repository.get(`/admin/customer/crm/snapshots/${id}`)
  },
  updateCustomerCrmSnapshot(id, payload) {
    return Repository.put(`/admin/customer/crm/snapshots/${id}`, payload)
  },
  viewCustomerCrmSnapShotSummary(customer_id) {
    return Repository.get(`/admin/customer/crm/snapshot/${customer_id}/summary`)
  },
  getSnapshotFinancialSummary(customer_id, filterQuery) {
    return Repository.get(`/admin/customer/crm/snapshot/${customer_id}/order-graph?${filterQuery}`)
  },
  deleteCustomerSnapshot(id) {
    return Repository.delete(`/admin/customer/crm/snapshots/${id}`)
  },

  //aggregated activities
  getListOfCustomerOpportunityActivities(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`/admin/customer/crm/opportunity-list?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getOpportunitySummary(filterQuery = '') {
    return Repository.get(`/admin/customer/crm/opportunity-summary?${filterQuery}`)
  },
  getListOfCustomerCommunicationActivities(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`/admin/customer/crm/communication-list?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getContactSummary(filterQuery = '') {
    return Repository.get(`/admin/customer/crm/communication-summary?${filterQuery}`)
  },
  fetchCampaignList() {
    return Repository.get('/admin/mail-chimp/campaigns')
  },
  fetchCrmOwnerSummary() {
    return Repository.get('/admin/marketing/lead/dashboard-summary')
  },
  increaseLeadOpenCount(id) {
    return Repository.put(`/admin/marketing/lead/${id}/count`)
  },

  //MAILCHIMP
  getCampaignOpenReport(id) {
    return Repository.get(`/admin/mail-chimp/report/${id}/open-details`)
  },
  getCampaignEmailActivityReport(id, customer_id = '') {
    return Repository.get(`/admin/mail-chimp/report/${id}/email-activity?customer-id=${customer_id}`)
  },

  getCrmDashbordReportData(filterQuery) {
    return Repository.get(`/admin/marketing/lead/summary?${filterQuery}`)
  },

  //ENQUIRIES
  getListOfLeadEnquiries(lead_id, filterQuery, pageNumber = 1, pagination = defaultPagination, sort = '') {
    return Repository.get(`/admin/marketing/leads/${lead_id}/enquiries?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getLeadEnquiryDetails(enquiry_id) {
    return Repository.get(`/admin/marketing/enquiries/${enquiry_id}`)
  },
  createLeadEnquiry(lead_id, payload) {
    return Repository.post(`/admin/marketing/leads/${lead_id}/enquiries`, payload)
  },
  updateLeadEnquiry(enquiry_id, payload) {
    return Repository.put(`/admin/marketing/enquiries/${enquiry_id}`, payload)
  },
  checkCompanyNameExisits(search_term) {
    return Repository.get(`/admin/marketing/lead/search-company?name=${search_term}&limit=20`)
  }
};
